import { SxProps, Theme } from '@mui/material';

export const pushSectionStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 1,
    mb: 3,
};

export const pushDescriptionStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

/** What to do when the switch cannot be used: read as advice, not as an error. */
export const pushHintStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.875rem',
};
